import {ExactSearchFilter} from "./search-filter";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";
import {estadosDeOpcion, TEXTO_ENVIADO} from "../../model/pedidos/estados-pedido-cliente";

/**
 * La opción «Enviado» del filtro anterior (antes de agrupar las opciones como la píldora). Se sigue entendiendo para
 * que una URL guardada con ella (historial, marcador) no deje de filtrar.
 */
export const FILTRO_ESTADO_ENVIADO_ANTIGUO = 'Enviado';

/**
 * Filtro de Estado del listado de pedidos del cliente. Sus opciones son los textos de la píldora de la columna
 * Estado (EN PRODUCCIÓN, ENVIADO…; la tabla está en estados-pedido-cliente.ts), y cada una pide a la API los estados
 * reales que se ven así (`estado[]=En producción&estado[]=En logística&...`, que el SearchFilter exacto de API
 * Platform resuelve con IN). Un valor que no es una opción (un estado real que llega de una URL antigua) va tal cual.
 * La tabla vive fuera del modelo para no importar el modelo desde aquí: el modelo usa este filtro en su decorador y
 * el import circular lo dejaría sin definir.
 */
export class EstadoPedidoClienteFilter extends ExactSearchFilter {
    dataToParams(property: InternalPropertyMap, data: any[] | any): { [p: string]: string | string[] } {
        const valores = [];
        for (const valor of (Array.isArray(data) ? data : [data])) {
            const opcion = valor === FILTRO_ESTADO_ENVIADO_ANTIGUO ? TEXTO_ENVIADO : valor;
            const estados = estadosDeOpcion(opcion);
            for (const estado of (estados.length > 0 ? estados : [valor])) {
                if (!valores.includes(estado)) {
                    valores.push(estado);
                }
            }
        }
        return super.dataToParams(property, valores.length === 1 ? valores[0] : valores);
    }
}
